<template>
  <modal
    name="prjeditor"
    :clickToClose="false"
    :resizable="true"
    :scrollable="true"
    :reset="true"
    height="auto"
    :width="modalWidth"
  >
    {{ $t("prjeditor.TITLE") }}
    <div class="dialogcontainer">
      <vue-form-generator
        :schema="schema"
        :model="editProjectData"
        :options="formOptions"
      ></vue-form-generator>
      <destinations v-model="editProjectData.dest" />
      <p></p>
    </div>
    <div class="buttonscontainer" align="center" style="padding: 6px">
      <button @click="onDiscard" class="quicktextbutton">
        {{ $t("editor.BUTTON_DISCARD") }}
      </button>
      <button @click="onSave" class="quicktextbutton">
        {{ $t("editor.BUTTON_SAVE") }}
      </button>
    </div>
  </modal>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import destinations from "./destinations.vue";

Vue.use(VueFormGenerator);

const MODAL_WIDTH = 656;
const MODAL_HEIGHT = 656;

export default {
  name: "editor",
  components: {
    destinations
  },
  props: {
    editProjectData: {}
  },
  data: function () {
    return {
      schema: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("prjeditor.FIELD_NAME"),
            model: "name",
            placeholder: this.$t("prjeditor.FIELD_NAME_PH"),
            featured: true,
            required: true
          },
          /*
          {
            type: "input",
            inputType: "text",
            label: this.$t("prjeditor.FIELD_SOURCE"),
            model: "options.source",
            placeholder: this.$t("prjeditor.FIELD_SOURCE_PH")
          },
          */
          {
            type: "checkbox",
            label: this.$t("prjeditor.FIELD_WORD_CONVERT"),
            model: "options.wordToArticle",
            default: true
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true
      },
      editing: false,
      modalWidth: MODAL_WIDTH,
      modalHeight: MODAL_HEIGHT
    };
  },
  created() {},
  methods: {
    async editFile() {
      this.modalWidth =
        window.innerWidth < MODAL_WIDTH ? window.innerWidth * 0.8 : MODAL_WIDTH;
      this.modalHeight =
        window.innerHeight < MODAL_HEIGHT
          ? window.innerHeight * 0.8
          : MODAL_HEIGHT;

      // In the editor component the prop associated to modalWidth would not be immediately updated
      // so we give enough time to Vue to propagate the change
      // in this way the width of the dialog will be properly set
      await this.$nextTick();
      this.editing = true;
      this.$modal.show("prjeditor");
    },
    onSave() {
      this.editing = false;
      this.$modal.hide("prjeditor");
      this.$emit("onSave");
    },
    onDiscard() {
      if (window.confirm(this.$t("prjeditor.DISCARD_MSG"))) {
        this.editing = false;
        this.$modal.hide("prjeditor");
      }
    },
    isEditing() {
      return this.editing;
    },
    // eslint-disable-next-line no-unused-vars
    onEditorReady(eventInfo) {}
  },
  mounted: function () {}
};
</script>
<style>
fieldset {
  border-width: 0em;
}

.field-checkbox input {
  margin-left: 12px;
  margin-bottom: 2px;
}
</style>
